export enum EligibilityStates {
  LOADING = "loading",
  ELIGIBLE = "eligible",
  INELIGIBLE = "ineligible",
}
